module.exports = __webpack_public_path__ + "img/sound-bg.ee43723a.png";